import Saransh from './images/Saransh.jpg';
import Alex from './images/alex.jpg';
import Emily from './images/ana.jpg';
import Bob from './images/bob.jpg';
import Gratique from './images/gratique.jpg';
import Sarah from './images/sarah.jpg';
import ucsdLogo from './images/ucsd-logo.png';
import uclaLogo from './images/ucla-logo.jpg';
import uscLogo from './images/usc-logo.jpg';
import uvaLogo from './images/uva-logo.jpg';
import pdf from './images/SaranshDabas_USC.pdf';
import pdfFirstPageImg from './images/pdfFirstPageImg.png';

export const newsData = [
  {
    id: 1,
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam qui numquam at expedita quae nihil laborum sint architecto, rerum soluta!',
    likes: 45,
    dislikes: 0,
    user: {
      name: 'Amey',
      img:
        'https://images.pexels.com/photos/1007066/pexels-photo-1007066.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=50&w=50',
    },
    date: '10-Jul-2020',
    tags: ['UCLA', 'university'],
  },
  {
    id: 2,
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam qui numquam at expedita quae nihil laborum sint architecto, rerum soluta!',
    likes: 29,
    dislikes: 0,
    user: {
      name: 'Amey',
      img:
        'https://images.pexels.com/photos/1007066/pexels-photo-1007066.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=50&w=50',
    },
    date: '10-Jul-2020',
    tags: ['UCB'],
  },
  {
    id: 3,
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam qui numquam at expedita quae nihil laborum sint architecto, rerum soluta! ',
    likes: 20,
    dislikes: 0,
    user: {
      name: 'Amey',
      img:
        'https://images.pexels.com/photos/1007066/pexels-photo-1007066.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=50&w=50',
    },
    date: '10-Jul-2020',
    tags: ['admiT'],
  },
  {
    id: 4,
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam qui numquam at expedita quae nihil laborum sint architecto, rerum soluta!',
    likes: 62,
    dislikes: 0,
    user: {
      name: 'Amey',
      img:
        'https://images.pexels.com/photos/1007066/pexels-photo-1007066.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=50&w=50',
    },
    date: '10-Jul-2020',
    tags: ['reject'],
  },
  {
    id: 5,
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
    text:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam qui numquam at expedita quae nihil laborum sint architecto, rerum soluta!',
    likes: 18,
    dislikes: 0,
    user: {
      name: 'Amey',
      img:
        'https://images.pexels.com/photos/1007066/pexels-photo-1007066.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=50&w=50',
    },
    date: '10-Jul-2020',
    tags: ['university'],
  },
];

export const suggestionsData = [
  { id: 1, name: 'UCLA' },
  { id: 2, name: 'Admit' },
  { id: 3, name: 'UCB' },
  { id: 4, name: 'Universities' },
];

export const profileData = {
  type: 'omega',
  firstName: 'Saransh',
  lastName: 'Dabas',
  university: 'University Of California - LA',
  gre: '320 (155V, 165Q, 3.5A)',
  toefl: '110 (R:27, W:27, S:26, L:30)',
  undergrad: 'VIT Vellore',
  undergradGPA: '9.40',
  researchPapers: [{ id: 1 }, { id: 2 }],
  workExperience: 24,
  phone: '+917010984129',
  email: 'saransh.dabas2015@vitalum.ac.in',
  imgUrl: Saransh,
  about:
    'I am a competitive programmer with good problem solving skills, mostly I do programming for fun, my area of interest is Internet Of Things. I have experience in android app development, building smart systems using raspberry pi and spring boot with JAVA for the backend development of web applications.',
};

export const profileSuggestions = [
  {
    id: 1,
    type: 'omega',
    name: 'Alex Buttoskwi',
    university: 'UCLA',
    designation: 'Senior Graduate',
    imgUrl: Alex,
  },
  {
    id: 2,
    type: 'alpha',
    name: 'Bob Anderson',
    university: 'USC',
    designation: 'Senior Graduate',
    imgUrl: Bob,
  },
  {
    id: 3,
    type: 'omega',
    name: 'Emily Williams',
    university: 'UCLA',
    designation: 'Senior Graduate',
    imgUrl: Emily,
  },
  {
    id: 4,
    type: 'omega',
    name: 'Sarah Johns',
    university: 'TAMU',
    designation: 'Admission comm.',
    imgUrl: Sarah,
  },
  {
    id: 5,
    type: 'alpha',
    name: 'Gratique Amal',
    university: 'UCSD',
    designation: 'Professor',
    imgUrl: Gratique,
  },
];

export const pendingRequests = [
  {
    id: 1,
    type: 'omega',
    firstName: 'Alex',
    lastName: 'Buttoskwi',
    university: 'UCLA',
    designation: 'Senior Graduate',
    imgUrl: Alex,
  },
  {
    id: 2,
    type: 'alpha',
    firstName: 'Bob',
    lastName: 'Anderson',
    university: 'USC',
    designation: 'Senior Graduate',
    imgUrl: Bob,
  },
  {
    id: 3,
    type: 'omega',
    firstName: 'Emily',
    lastName: 'Williams',
    university: 'UCLA',
    designation: 'Senior Graduate',
    imgUrl: Emily,
  },
  {
    id: 4,
    type: 'omega',
    firstName: 'Sarah',
    lastName: 'Johns',
    university: 'TAMU',
    designation: 'Admission comm.',
    imgUrl: Sarah,
  },
  {
    id: 5,
    type: 'alpha',
    firstName: 'Gratique',
    lastName: 'Amal',
    university: 'UCSD',
    designation: 'Professor',
    imgUrl: Gratique,
  },
];

export const universityImgSrc = {
  1: ucsdLogo,
  2: uclaLogo,
  3: uscLogo,
  4: uvaLogo,
  5: uvaLogo,
};
export const pdfDetails = [
  { id: 1, name: 'UCSD', imgUrl: pdfFirstPageImg },
  { id: 2, name: 'UCLA', imgUrl: pdfFirstPageImg },
  { id: 3, name: 'USC', imgUrl: pdfFirstPageImg },
  { id: 4, name: 'UVA', imgUrl: pdfFirstPageImg },
];

export const connections = [
  {
    id: 1,
    type: 'omega',
    firstName: 'Alex',
    lastName: 'Buttowski',
    university: 'University Of California - LA',
    uniShort: 'UCLA',
    position: 'Senior Graduate',
    greTotal: '320',
    greVerbal: '155',
    greQuants: '165',
    toeflTotal: '110',
    toeflReading: '29',
    toeflWriting: '29',
    toeflSpeaking: '25',
    toeflListening: '27',
    undergrad: 'VIT Vellore',
    undergradGPA: '9.40',
    researchPapers: [{ id: 1 }, { id: 2 }],
    workExperience: 24,
    phone: '+917010984129',
    email: 'saransh.dabas2015@vitalum.ac.in',
    imgUrl: Alex,
  },
  {
    id: 2,
    type: 'omega',
    firstName: 'Alex',
    lastName: 'Buttowski',
    university: 'University Of California - LA',
    uniShort: 'UCLA',
    position: 'Senior Graduate',
    greTotal: '320',
    greVerbal: '155',
    greQuants: '165',
    toeflTotal: '110',
    toeflReading: '29',
    toeflWriting: '29',
    toeflSpeaking: '25',
    toeflListening: '27',
    undergrad: 'VIT Vellore',
    undergradGPA: '9.40',
    researchPapers: [{ id: 1 }, { id: 2 }],
    workExperience: 24,
    phone: '+917010984129',
    email: 'saransh.dabas2015@vitalum.ac.in',
    imgUrl: Alex,
  },
  {
    id: 3,
    type: 'omega',
    firstName: 'Alex',
    lastName: 'Buttowski',
    university: 'University Of California - LA',
    uniShort: 'UCLA',
    position: 'Senior Graduate',
    greTotal: '320',
    greVerbal: '155',
    greQuants: '165',
    toeflTotal: '110',
    toeflReading: '29',
    toeflWriting: '29',
    toeflSpeaking: '25',
    toeflListening: '27',
    undergrad: 'VIT Vellore',
    undergradGPA: '9.40',
    researchPapers: [{ id: 1 }, { id: 2 }],
    workExperience: 24,
    phone: '+917010984129',
    email: 'saransh.dabas2015@vitalum.ac.in',
    imgUrl: Alex,
  },
  {
    id: 4,
    type: 'omega',
    firstName: 'Alex',
    lastName: 'Buttowski',
    university: 'University Of California - LA',
    uniShort: 'UCLA',
    position: 'Senior Graduate',
    greTotal: '320',
    greVerbal: '155',
    greQuants: '165',
    toeflTotal: '110',
    toeflReading: '29',
    toeflWriting: '29',
    toeflSpeaking: '25',
    toeflListening: '27',
    undergrad: 'VIT Vellore',
    undergradGPA: '9.40',
    researchPapers: [{ id: 1 }, { id: 2 }],
    workExperience: 24,
    phone: '+917010984129',
    email: 'saransh.dabas2015@vitalum.ac.in',
    imgUrl: Alex,
  },
];
